<template>
    <div class="pt1x fs12x">
        <div>
            <p class="lh15 ml1x pr1x cSub">{{getLanguageStr('manage395','注意：发电功率补0设置用于在夜间不发电时发电设备的发电功率为空的的情况。开启该设置后，系统将自动为此时间段内的发电功率补0。（该设置仅用于分布式自发自用余电上网电站在夜间无法通过算法计算出用电功率的现象。）')}}</p>
            <div>
                <div class="bdSub-top ml1x h4">{{getLanguageStr('manage396','启用该设置')}} <OnOff class="ml05x" :size="'small'" v-model="setOpen" @on-change="change"></OnOff></div>
                <div v-show="setOpen">
                    <div class="ml1x h4"><span class="cSub">{{getLanguageStr('manage397','生效时间设置')}}</span> </div>
                    <ul class="chooseTime ml1x">
                        <li  @click="changeMode(item.value)" class="pr1x" v-for="(item,index) in modeList" :key="index">
                             {{item.name}}   <span class="fR"> 
                                    <Radio
                                    name="choose"
                                    :label="item.value"
                                    v-model="mode"
                                    :checkObj='item'
                                    :index='index'
                                    :value="item.value"
                                   ></Radio>
                                </span>
                        </li>
                    </ul>
                    <ul class="chooseTime ml1x"  v-show="mode==='CUSTOM'">
                        <li>
                            {{getLanguageStr('manage400','开启时段')}}
                             <div class="fR">
                                <Select class="fR" :list="minutesList" :bindActive="openTime.minutes" :keyMap="{text:'name',value:'value'}" @Click="targetIndex=>setTime({'minutes':minutesList[targetIndex].value},'openTime')"></Select>
                                <div class="dpIB fR mr05x">:</div>
                                <Select class="fR mr05x" :list="hoursList" :bindActive="openTime.hours" :keyMap="{text:'name',value:'value'}" @Click="targetIndex=>setTime({'hours':hoursList[targetIndex].value},'openTime')"></Select>
                            </div>
                        </li>
                        <li>
                            <div class="fR">
                                <span v-show="nextDayShow">{{getLanguageStr('manage394','次日')}}</span>
                                <Select class="fR" :list="minutesList" :bindActive="closeTime.minutes" :keyMap="{text:'name',value:'value'}" @Click="targetIndex=>setTime({'minutes':minutesList[targetIndex].value},'closeTime')"></Select>
                                <div class="dpIB fR mr05x">:</div>
                                <Select class="fR mr05x" :list="hoursList" :bindActive="closeTime.hours" :keyMap="{text:'name',value:'value'}" @Click="targetIndex=>setTime({'hours':hoursList[targetIndex].value},'closeTime')"></Select>
                            </div>{{getLanguageStr('manage401','关闭时段')}}</li>
                    </ul>
                    <span class="fs08x cSub ml1x mt1x dpIB lh20" v-show="mode==='NATURE'">{{getLanguageStr('manage399','为避免误差，日落前1小时、日出后1小时内仍无发电功率数据，系统将仍然自动补零。')}} </span>
                    <div class="taC">
					    <button class="bdSub boxR hover-bg-highLight w8x sizeM mt2x mr2x" type="button" @click="cancel">{{$t('cmd85',['取消'])}}</button>
					    <button class="functionBtn w8x mt2x mb2x sizeM" type="button" @click="save">{{$t('cmd84',['保存'])}}</button>
				    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import OnOff from '@/components/common/ui/OnOff.vue'
import Select from '@/components/common/ui/Select.vue'
import Radio from '@/components/common/ui/Radio.vue'
import {getGenerationZero,setGenerationZero} from '@/api/maintain/config/index.js'
export default {
    name:'StationFill',
    components:{OnOff,Select,Radio},
    props: {
        stationId:{
			type:Number,
			default: 0
		}
    },
    data(){
        return{
            mode:'NATURE',
            setOpen:false,
            nextDayShow:false,
            modeList:[
                {name:getLanguageStr('manage391','日落至日出'),value:'NATURE'},
                {name:getLanguageStr('manage398','自定义段'),value:'CUSTOM'}
                ],
            hoursList: (function () {
                let y = lib.getTypeText('', 'fillHours', true)
                return y
            }()),
            minutesList: (function () {
                let y = lib.getTypeText('', 'fillMinutes', true)
                return y
            }()),
            openTime:{
                hours:0,
                minutes:'00'
            },
            closeTime:{
                hours:0,
                minutes:'00'
            }
        }
    },
     watch: {
        'openTime.hours'(newVal,oldVal) {
            this.openTime.hours=newVal;
            this.whetherToShow()
        },
        'openTime.minutes'(newVal,oldVal) {
            this.openTime.minutes=newVal;
            this.whetherToShow()
        },
        'closeTime.hours'(newVal,oldVal) {
            this.closeTime.hours=newVal;
            this.whetherToShow()
        },
        'closeTime.minutes'(newVal) {
            this.closeTime.minutes=newVal;
            this.whetherToShow()
        }
  },
    methods:{
        getLanguageStr,
        whetherToShow(){
            let sNumber=0,eNumber=0;
            sNumber=this.openTime.hours*60+Number(this.openTime.minutes)
            eNumber=this.closeTime.hours*60+Number(this.closeTime.minutes)
            if(sNumber>eNumber){
                this.nextDayShow=true
            }else{
                this.nextDayShow=false
            }
        },
        reset(){
            this.setOpen=false;
            this.mode='NATURE'
            this.openTime={
                hours:0,
                minutes:'00'
            }
            this.closeTime={
                hours:0,
                minutes:'00'
            }
        },
        show(res){
                if(res&&JSON.stringify(res) != "{}"){
                    if(res.onOff=='1'){
                        this.setOpen=true;
                    }else{
                        this.setOpen=false;
                    }
                    this.mode=res.timeType
                    if(res.startMinutes<10){
                        this.openTime.minutes='0'+String(res.startMinutes)
                    }else{
                        this.openTime.minutes=String(res.startMinutes);
                    }
                    if(res.endMinutes<10){
                        this.closeTime.minutes='0'+String(res.endMinutes)
                    }else{
                        this.closeTime.minutes=String(res.endMinutes);
                    }
                    this.openTime.hours=res.startHours
                    this.closeTime.hours=res.endHours
                }
        },
        changeMode(v){
            this.mode=v
        },
        setTime(data,type){
            if(type=='openTime'){
                this.openTime={...this.openTime,...data}
            }else{
                this.closeTime={...this.closeTime,...data}
            }
        },
        change(){
            if(!this.setOpen){
                this.reset();
                this.$emit('filltextShow')
                this.save();
            }else{
                 this.mode='NATURE'
            }
        },
        save(){
            let onOff=0;
            if(this.setOpen){
                onOff=1
            }else{
                onOff=0
            }
            if(this.mode=="CUSTOM"&&this.openTime.hours==this.closeTime.hours&&this.openTime.minutes==this.closeTime.minutes){
                this.$notify(getLanguageStr('plant473','关闭时段不能与开启时段一致'))
                return ;
            }else{
                let data={
                    "endHours":this.closeTime.hours,
                    "endMinutes":Number(this.closeTime.minutes),
                    "onOff": onOff,
                    "powerStationId": this.stationId,
                    "startHours": this.openTime.hours,
                    "startMinutes":Number(this.openTime.minutes),
                    "timeType": this.mode
                }
                setGenerationZero(this.stationId,data).then(res => {
                    this.$emit('setLeave',0)
                    this.$emit('filltextShow')
                    this.$emit('refresh')
                }, error => {
                    !_.isEmpty(error) && this.$notify(error)
                });
            }
        },
        cancel(){
            this.reset()
            this.$emit('setLeave',0)
        }
    }
}
</script>
<style lang="scss" scoped>
.chooseTime li,.h4{
    padding-top: 1em;
    padding-bottom: 1em;
    height: 4em;
    line-height: 2em;
    border-bottom: 1px solid rgba(#000,.05);
    padding-right: 1em;
}
</style>


// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationFill.vue